/**
 * Directional jump right gesture
 * @module gestures/transforms/jumpRight
 */
import { createJumpGesture } from './jumpFactory.js';
export default createJumpGesture('right');
